import type {CohortADto} from '@cohort/admin-schemas/cohort';
import {CohortTypeBadge} from '@cohort/merchants/components/cohorts/CohortTypeBadge';
import Table from '@cohort/merchants/components/Table';
import {getCohortMembersRoute} from '@cohort/merchants/lib/Pages';
import {formatDate} from '@cohort/shared/utils/format';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

type CohortsTableProps = {
  cohorts: CohortADto[];
  isLoading: boolean;
};

const CohortsTable: React.FC<CohortsTableProps> = ({cohorts, isLoading}) => {
  const navigate = useNavigate();
  const {t} = useTranslation('pages', {keyPrefix: 'users.cohorts.cohortsTable'});

  const headers = [
    {label: t('tableHeaderName')},
    {label: t('tableHeaderType')},
    {label: t('tableHeaderMembers')},
    {label: t('tableHeaderCreated')},
  ];

  return (
    <Table
      headers={headers}
      isLoading={isLoading}
      emptyState={{
        isEmpty: cohorts.length === 0,
        title: t('titleEmpty'),
        description: t('descriptionEmpty'),
      }}
    >
      {cohorts.map(cohort => (
        <tr
          key={cohort.id}
          className="cursor-pointer py-4 text-sm hover:bg-slate-50"
          onClick={() => navigate(getCohortMembersRoute(cohort.id).path)}
        >
          <td className="py-3 pr-1 font-semibold">{cohort.name}</td>
          <td className="py-3 pr-1">
            <CohortTypeBadge type={cohort.type} />
          </td>
          <td className="pr-1 text-muted-foreground">{cohort.usersCount ?? ''}</td>
          <td className="pr-1 text-muted-foreground">{formatDate(cohort.createdAt)}</td>
        </tr>
      ))}
    </Table>
  );
};

export default CohortsTable;
